import { useState, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useWindowSize } from '@uidotdev/usehooks';
import Carousel from '@molecules/Carousel';
import DownloadAppQrCode from '@molecules/DownloadAppQrCode';
import { Image } from '@ui/atoms';
import { getSlugPathFromUrl, triggerCustomGaEvent } from '@helpers/miscelleanous';
import { showAppDownloadBanner } from '@helpers/constants';

const CarouselBanner = ({ banners = [], isLogged }) => {
    const router = useRouter();
    const { width } = useWindowSize();
    const [showAppDownloadPrompt, setShowAppDownloadPrompt] = useState(false);

    const sortedPriorityBanners = useMemo(
        () => banners.sort((a, b) => a.priority - b.priority),
        [banners]
    );

    const redirect = (banner) => {
        const url = width >= 1024 ? banner?.redirectWebLink : banner?.redirectAppLink;

        if (banner?.isNewTab) {
            window.open(url, '_blank');
        } else {
            if (url.includes('#app-download')) {
                setShowAppDownloadPrompt(true);
            }
            router.push(url);
        }

        triggerCustomGaEvent(banner.gaTrigger1)
    };

    const renderBannerImage = (banner) => (
        <>
            <Image
                src={`/homepage/carousel-banner/${getSlugPathFromUrl(banner?.webLink)}`}
                className="w-full xl:block hidden"
                alt='desktop-banner'
            />
            <Image
                src={`/homepage/carousel-banner/${getSlugPathFromUrl(banner?.tabLink)}`}
                className="w-full md:block xl:hidden hidden max-w-[768px] mx-auto"
                alt='tab-banner'
            />
            <Image
                src={`/homepage/carousel-banner/${getSlugPathFromUrl(banner?.mobileLink)}`}
                className="w-full block md:hidden"
                alt='mobile-banner'
            />
        </>
    );

    const renderBannerItem = (banner, idx) => ({
        children: (
            <div className="w-full relative" key={idx}>
                {renderBannerImage(banner)}
                {banner?.description && (
                    <>
                        <div
                            dangerouslySetInnerHTML={{ __html: banner.description }}
                        />
                        {/* Required classnames for custom description position */}
                        <div className="hidden">
                            absolute -bottom-48 -bottom-32 right-0 flex justify-end ml-auto mascot xl:block hidden
                            w-[76px] h-[58px] coin animate-bounce top-[96px] sticky top-0 xl:w-[356px] mascot
                        </div>
                    </>
                )}
            </div>
        ),
        onClick: () => redirect(banner),
    });

    return (
        <div
            className={`mt-16 relative ${showAppDownloadBanner ? 'xl:h-[calc(100svh-120px)]' : 'xl:h-screen'} pb-10 ${isLogged ? 'min-h-[566px]' : ''} xl:pb-0 xl:max-h-[900px]`}
        >
            <div className="max-w-7xl mx-auto flex flex-col pt-2 xl:pt-10">
                <Carousel
                    autoPlay={true}
                    autoPlayInterval={5000}
                    items={sortedPriorityBanners.map(renderBannerItem)}
                    infinite
                    showNextPrevButtons={false}
                />
            </div>

            {showAppDownloadPrompt && (
                <DownloadAppQrCode
                    show={showAppDownloadPrompt}
                    onClose={() => setShowAppDownloadPrompt(false)}
                />
            )}

            <Image src='/images/background/jiraaf-banner-carousel.svg' className='absolute w-full h-screen bottom-0 -z-0 left-0 hidden md:block'/>
            <Image src='/images/background/jiraaf-banner-carousel-mobile.svg' className='absolute w-full h-screen -bottom-40 -z-0 left-0 md:hidden'/>
        </div>
    );
};

export default CarouselBanner;